<div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
<div>
    <p class="p-3 h5">{{delayText}}</p>
</div>